import React from "react";
import Chart from "react-apexcharts";

const FinancialChart=({series})=>{
    const chartOption = {
        type: 'bar',
        height: "auto",
        options: {
            fill: {
                colors: ['#F44336', '#E91E63', '#9C27B0']
            },
            chart: {
                id: 'support-chart',

                sparkline: {
                    enabled: false
                },

            },
            dataLabels: {
                enabled: false
            },
            xaxis: {
                categories: ["FAR","ORD","KHO","TIR","MOR","SHA","MEH","ABA","AZA","DAY","BAH","ESF"],
                style: {
                    fontSize: '10px',
                    colors: ["#0978cb"]
                },
                axisBorder: {
                    show: false
                },
                axisTicks: {
                    show: true
                },

            },

            yaxis: {
                axisBorder: {
                    show: true
                },
                axisTicks: {
                    show: false,
                },
                labels: {
                    show: false,
                }
            },
            tooltip: {
                fixed: {
                    enabled: false
                },
                x: {
                    show: true
                },
                y: {
                    show:true,
                },
                marker: {
                    show: false
                }
            }
        },
        series: [
            {
                name: ' تومان ',
                data: series,
                color: "#dc3545"
            },
        ]
    };
    return(
        <Chart  {...chartOption} />
    )


}
export default FinancialChart;